<template>
  <v-dialog v-model="dialog" persistent width="1300">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>picture_as_pdf</v-icon> REPORTE </v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon title="Ver en otra ventana" @click="openNewWindow()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <embed
              :src="this.url"
              type="application/pdf"
              width="100%"
              height="700px"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // Variables iniciales
  data() {
    return {
      form: {},
      dialog: false,
      loading: false,
      url: "",
      api_backend: ""
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerReporte", item => {
      //this.tipo_documento = this.obtenerTipo(item)
      this.form = item;
      this.url = "";
      this.url = item;
      this.api_backend = process.env.API_URL.split("api/");
      this.dialog = true;
    });
  },
  methods: {
    // obtenerUrl() {
    //   try {
    //     let url;
    //     let nombre_reporte = "";
    //     let formato_doc = "output=pdf";
    //     let nombre_carpeta = "permisos";
    //     let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
    //       /{carpeta}/g,
    //       nombre_carpeta
    //     );
    //     if (this.form.tipo==1) { //reporte general
          
    //     } else {//reporte por servidor
          
    //     }
    //       nombre_reporte = "rpt_permiso_oficial_horas";
        
    //     url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
    //     //Parametros
    //     let id_permiso = this.form.id_permiso;
    //     // URL con parametros
    //     let url_parametros = `${url}&p_id_permiso=${id_permiso}`;
    //     console.log(url_parametros)
    //     return url_parametros;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    close() {
      this.loading = false;
      this.dialog = false;
      this.url=""
    },
    openNewWindow() {
      window.open(this.url);
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/tipificacion/dialogs/VerReporte.vue